import React from "react";

const ITENS = [
  { href: "/admin/metricas", icone: "📊", titulo: "Resultados do curso", texto: "Quem começou, terminou e comprou" },
  { href: "/admin/products", icone: "🛒", titulo: "Produtos da loja", texto: "Cadastrar, mudar preço, fotos e estoque" },
  { href: "/admin/pagamentos-curso", icone: "💰", titulo: "Compras do curso", texto: "Conferir o PIX e liberar módulos" },
  { href: "/livro-caixa", icone: "📒", titulo: "Livro Caixa", texto: "Entradas e saídas" },
  { href: "/admin", icone: "👥", titulo: "Cadastros e alunos", texto: "Ver e editar contas" },
  { href: "/loja-publica", icone: "🏪", titulo: "Ver a loja como cliente", texto: "Como o cliente vê o site" },
  { href: "/curso/aluno", icone: "🎓", titulo: "Voltar para a Área do Aluno", texto: "" },
];

export default function AdminPainelPage() {
  return (
    <div className="min-h-screen bg-[#141118] text-[#F2F0EA] px-4 py-8" style={{ fontFamily: "Manrope" }}>
      <div className="max-w-xl mx-auto">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo-giraia.jpg" alt="Giraia Bike Shop" className="w-24 h-24 rounded-full object-cover" />
          <h1 className="text-2xl font-bold text-[#E2B84A] mt-3" style={{ fontFamily: "Outfit" }}>Painel da Loja</h1>
          <p className="text-sm text-gray-400">Só administradores veem esta página</p>
        </div>
        <div className="grid gap-3">
          {ITENS.map((i) => (
            <a key={i.href} href={i.href} className="flex items-center gap-4 p-4 rounded-xl border border-[#E2B84A]/40 bg-white/5 active:bg-[#E2B84A]/20">
              <span className="text-3xl">{i.icone}</span>
              <span>
                <span className="block text-lg font-semibold">{i.titulo}</span>
                {i.texto && <span className="block text-sm text-gray-400">{i.texto}</span>}
              </span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
